import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'
import { rem } from 'polished'
import noop from 'lib/function/noop'

const ClickableWrapper = styled.button`
  flex: 1;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${rem(10)} 0;
  margin: ${rem(-10)} 0;
`

const Container = styled.div`
  height: ${rem(3)};
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: ${rem(2)};
  overflow: hidden;
`

const Fill = styled.div`
  height: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border-radius: inherit;
  width: 0%;

  &.is-completed {
    width: 100%;
  }

  &.is-active {
    animation: fillProgress var(--slide-duration) linear forwards;
  }

  &.is-paused {
    animation-play-state: paused;
  }

  @keyframes fillProgress {
    from {
      width: 0%;
    }
    to {
      width: 100%;
    }
  }
`

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive: boolean
  isCompleted: boolean
  isPaused: boolean
  duration: number
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  'data-index'?: number
}

function WrappedProgressBar({
  isActive,
  isCompleted,
  isPaused,
  duration,
  onClick = noop,
  'data-index': dataIndex,
  ...rest
}: Props) {
  return (
    <ClickableWrapper
      {...rest}
      type="button"
      onClick={onClick}
      data-index={dataIndex}
    >
      <Container>
        <Fill
          className={cn({
            'is-active': isActive,
            'is-completed': isCompleted,
            'is-paused': isPaused,
          })}
          style={{ '--slide-duration': `${duration}ms` } as React.CSSProperties}
        />
      </Container>
    </ClickableWrapper>
  )
}

export default React.memo(WrappedProgressBar)
